import { Component, computed, input } from '@angular/core';
import { NotificationLayoutComponent } from '../../notification-detail-layout/notification-detail-layout.component';
import { NotificationStep, TeacherNotification } from '../../../core/models/notification.model';

@Component({
  selector: 'wf-mid-assessment-reminder-notification',
  imports: [
    NotificationLayoutComponent
  ],
  template: `
    <wf-notification-layout
      headerTitle="🎯 Big milestone ahead"
      [preambles]="[
        {
          text: 'The student(s) below are just beginning Unit 12 — the halfway point in the WordFlight curriculum. '
            + 'That\\’s amazing progress! At the end of Unit 12, they’ll complete the Objective 3 Posttest, '
            + 'followed by the Mid Diagnostic. This is an important checkpoint for measuring growth.'
        },
        {
          text: 'In the next two weeks, help set your student up for success:',
          isSubheading: true,
        }
      ]"
      [steps]="steps"
      [ids]="ids()"
      ctaLabel="Open Diagnostic Results"
      ctaRoute="/reports/system/diagnostic"
      closingText="You’re doing great work — good luck to you and your student(s)!"
    >
      <table table class="table-wrap">
        <tr>
          <th class="th">Student</th>
        </tr>
        @for (notification of data(); track notification.alertID) {
          <tr>
            <td class="td">{{ notification.studentName }}</td>
          </tr>
        }
      </table>
    </wf-notification-layout>
  `,
  standalone: true
})
export class MidAssessmentReminderNotificationComponent {
  readonly data = input.required<TeacherNotification[] | null>();
  readonly ids = computed(() => {
    const notifications = this.data() ?? [];

    return { alerts: notifications.map(notification => notification.alertID) };
  });
  readonly steps: NotificationStep[] = [
    {
      title: 'Give them a heads up',
      body: 'Let them know an important Diagnostic is coming that’s a little different from recent tasks — there’s no right/wrong feedback during the Diagnostic itself.'
    },
    {
      title: 'Build some excitement',
      body: 'Extra points are available during the Diagnostic, and students can earn a special character if they show improvement over their last Diagnostic. That’s worth getting excited about!',
    },
    {
      title: 'Set the right mindset',
      body: 'Let them know you’ll review the results together. Remind them to focus, take their time, and bring their best effort — it’s a chance to show how much they’ve grown.',
    },
    {
      title: 'Track their progress',
      body: 'Open the Diagnostic Results report anytime to check how far along they are — progress is shown as a percentage. You’ll also get a notification when they finish.',
      variant: 'green',
    }
  ];
}
